import * as React from 'react'

import Select from 'react-select'
import {DataFilters} from '../../core/components/DataFilters/DataFilters'
import {GeometryType} from '../../core/enums/GeometryType'
import {ControlType, IControlQuery, IFieldInfo} from '../../core/interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import {LocationSelector} from '../App/LocationSelector'

class AppDataFilters extends DataFilters {
  protected getControlQuery(fieldInfo: IFieldInfo, controlQuery?: IControlQuery): IControlQuery {
    if (fieldInfo.fieldName == 'LocationSelector') {
      let controlType: ControlType
      let controlValue = undefined
      if (controlQuery) {
        controlType = controlQuery.controlType
        controlValue = controlQuery.controlValue
      } else {
        controlType = ControlType.MultiSelect
        controlValue = {}
      }
      const controlQueryResult: IControlQuery = {
        controlType: controlType,
        controlValue: controlValue,
        queryTarget: this.state.queryTarget,
        where: controlQuery ? controlQuery.where : ''
      }
      return controlQueryResult
    }
    return super.getControlQuery(fieldInfo, controlQuery)
  }

  protected getEnumMultiSelectEditingControl(currentValue: any, fieldName: string, fieldInfo: IFieldInfo) {
    if (
      this.props.layerInfo.url == appConfig.reg.parcels.parcelsUrl ||
      this.props.layerInfo.url == appConfig.reg.quarters.quartersUrl
    ) {
      if (fieldName == 'PlanTypeId') {
        const options: {value: any; label: any}[] = []
        fieldInfo.codedValues!.forEach(c => {
          options.push({value: c.code, label: c.name})
        })
        return (
          <Select
            className="w"
            isMulti={true}
            closeMenuOnSelect={false}
            value={currentValue}
            placeholder={`Изберете ${fieldInfo.label}...`}
            onChange={(newValues: {value: any; label: any}[]) => {
              const sqlArray: string[] = []
              if (newValues) {
                newValues.forEach(v => {
                  sqlArray.push(v.value)
                })
              }

              this.onFieldValueChange(
                fieldName,
                ControlType.MultiSelect,
                newValues,
                sqlArray.length > 0
                  ? `"RegPlanId" IN (select "Id" from reg."RegPlan" where "RegPlanTypeId" IN (${sqlArray.join(',')}))`
                  : ''
              )
            }}
            options={options}
          />
        )
      }
    }
    return super.getEnumMultiSelectEditingControl(currentValue, fieldName, fieldInfo)
  }
  protected getStringEditingControl(
    controlValue: React.ReactText | undefined,
    fieldName: string,
    fieldInfo: IFieldInfo
  ) {
    if (this.props.layerInfo.url == appConfig.reg.parcels.parcelsUrl) {
      if (fieldName == 'QuarterNumber') {
        const onFieldValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          this.onFieldValueChange(
            fieldName,
            ControlType.StringInput,
            e.target.value,
            e.target.value
              ? `"QuarterId" IN (select "Id" from reg."Quarter" where "QuarterNumber" = '${e.target.value}')`
              : ''
          )
        }

        if (fieldInfo.length && fieldInfo.length > 255) {
          return (
            <textarea
              onFocus={() => this.setState({...this.state, currentlyFocused: fieldName})}
              style={{width: '100%', resize: 'vertical'}}
              className="form-control"
              rows={4}
              value={controlValue === undefined || controlValue === null ? '' : controlValue}
              onChange={onFieldValueChange}
            ></textarea>
          )
        }
        return (
          <input
            onFocus={() => this.setState({...this.state, currentlyFocused: fieldName})}
            className="form-control"
            type="text"
            value={controlValue === undefined || controlValue === null ? '' : controlValue}
            onChange={onFieldValueChange}
          ></input>
        )
      }
    }
    if (
      this.props.layerInfo.url == appConfig.reg.parcels.parcelsUrl ||
      this.props.layerInfo.url == appConfig.reg.quarters.quartersUrl
    ) {
      if (fieldName == 'PlanName') {
        const onFieldValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          this.onFieldValueChange(
            fieldName,
            ControlType.StringInput,
            e.target.value,
            e.target.value
              ? `"RegPlanId" IN (select "Id" from reg."RegPlan" where upper("PlanName") LIKE '${e.target.value.toUpperCase()}%')`
              : ''
          )
        }

        if (fieldInfo.length && fieldInfo.length > 255) {
          return (
            <textarea
              onFocus={() => this.setState({...this.state, currentlyFocused: fieldName})}
              style={{width: '100%', resize: 'vertical'}}
              className="form-control"
              rows={4}
              value={controlValue === undefined || controlValue === null ? '' : controlValue}
              onChange={onFieldValueChange}
            ></textarea>
          )
        }
        return (
          <input
            onFocus={() => this.setState({...this.state, currentlyFocused: fieldName})}
            className="form-control"
            type="text"
            value={controlValue === undefined || controlValue === null ? '' : controlValue}
            onChange={onFieldValueChange}
          ></input>
        )
      }
    }
    return super.getStringEditingControl(controlValue, fieldName, fieldInfo)
  }
  protected getInitControls() {
    if (
      appConfig.reg.regrelated.indexOf(this.props.layerInfo.url) != -1 ||
      this.props.layerInfo.url == appConfig.reg.plan.planUrl ||
      appConfig.misc.miscrelated.indexOf(this.props.layerInfo.url) != -1
    ) {
      const fieldInfo: IFieldInfo = {
        fieldName: 'LocationSelector',
        label: 'Локация',
        visible: true,
        geometryType: GeometryType.None,
        z: 0
      }
      const controlQuery = this.getControlQuery(fieldInfo, this.state.controledQueries['LocationSelector'])
      return [
        <LocationSelector
          key="LOCATIONSELECTOR"
          onSettlementsChange={(locs, sett, loc) => {
            let where = ''
            if (
              this.props.layerInfo.url == appConfig.reg.plan.planUrl ||
              appConfig.misc.miscrelated.indexOf(this.props.layerInfo.url) != -1
            ) {
              if (loc) {
                where = `"LocalityId" = ${loc.getProperties()['Id']}`
              } else if (sett) {
                where = `"LocalityId" IN (${locs.map(loc => loc.getProperties()['Id']).join(',')})`
              }
            } else {
              if (loc) {
                where = `"RegPlanId" IN (select "Id" from reg."RegPlan" where "LocalityId" = ${
                  loc.getProperties()['Id']
                })`
              } else if (sett) {
                where = `"RegPlanId" IN (select "Id" from reg."RegPlan" where "LocalityId" IN (${locs
                  .map(loc => loc.getProperties()['Id'])
                  .join(',')}))`
              }
            }

            this.onFieldValueChange('LocationSelector', ControlType.MultiSelect, {loc, sett}, where)
          }}
          selectedLocation={controlQuery.controlValue.loc}
          selectedSettlemet={controlQuery.controlValue.sett}
        />
      ]
    }
    return []
  }
}

export default AppDataFilters
